import React from "react";

function NFTMarketplaceHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  NFT Marketplace Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology, we offer comprehensive NFT marketplace
                    development services tailored to your specific business
                    model and industry needs!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTMarketplaceHero;
